<template>
  <div class="heading-2" data-slot="p-1">
    <div class="heading-2-title">
      <slot name="p-1">
        <p>تیتر</p>
      </slot>
    </div>
    <div class="words" data-slot="p-2">
      <slot name="p-2">
        <span class="word">متن 1</span>
        <span class="word">متن 2</span>
        <span class="word">متن 3</span>
        <span class="word">متن 4</span>
      </slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "Card908"
}
</script>

<style scoped>
.heading-2 {
  color: var(--dark);
  -webkit-box-sizing: content-box;
  box-sizing: content-box;
  height: 40px;
  padding: 10px 10px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  border-radius: 8px;
}

.words {
  overflow: hidden;
}

.words >>> .word {
  display: block;
  height: 100%;
  padding-right: 6px;
  color: var(--primary);
  animation: spin_4991 4s infinite;
}

@keyframes spin_4991 {
  10% {
    -webkit-transform: translateY(-105%);
    transform: translateY(-105%);
  }

  25% {
    -webkit-transform: translateY(-100%);
    transform: translateY(-100%);
  }

  35% {
    -webkit-transform: translateY(-205%);
    transform: translateY(-205%);
  }

  50% {
    -webkit-transform: translateY(-200%);
    transform: translateY(-200%);
  }

  60% {
    -webkit-transform: translateY(-305%);
    transform: translateY(-305%);
  }

  75% {
    -webkit-transform: translateY(-300%);
    transform: translateY(-300%);
  }

  85% {
    -webkit-transform: translateY(-405%);
    transform: translateY(-405%);
  }

  100% {
    -webkit-transform: translateY(-400%);
    transform: translateY(-400%);
  }
}

</style>